import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fbb6978"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "modal-footer" }

import $ from 'jquery';
import { head } from 'lodash';
import { ref, watch, inject } from 'vue';

// Define state with ref() and specify initial values

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertDialog',
  props: {
    name: {}
  },
  emits: ['alertDialogClosed'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const title = ref('title');
const titlestyle = ref('');
const message = ref('message');
const messagestyle = ref('');
const button1text = ref('OK');
const button2text = ref('Cancel');
const buttonstyle = ref('');
const id = ref();
const props = __props;

// Define emits
const emit = __emit;

// Initialize component with props
const init = (t: string, m: string, bt1: string, bt2: string, idValue: string) => {
  title.value = t;
  message.value = m;
  button1text.value = bt1;
  button2text.value = bt2;
  id.value = idValue;
};
// Methods
const button1Clicked = () => {
  emit("alertDialogClosed", id.value, button1text.value);
  hide();
};
const button2Clicked = () => {
  emit("alertDialogClosed", id.value, button2text.value);
  hide();
};

const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = () => {
  emit("alertDialogClosed", '', '');
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
  }
};
__expose({ init, show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal alert-dialog",
    "data-backdrop": "static",
    "data-keyboard": "false",
    tabindex: "-1",
    role: "dialog",
    id: _ctx.name,
    "aria-labelledby": "`alert-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", {
            class: _normalizeClass(["modal-title", titlestyle.value]),
            id: "alert-modal-label"
          }, _toDisplayString(title.value), 3),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-md-12", messagestyle.value])
            }, [
              _createElementVNode("h5", null, _toDisplayString(message.value), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (button2text.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["btn btn-outline-primary mr-auto", buttonstyle.value]),
                "data-dismiss": "modal",
                onClick: button2Clicked
              }, _toDisplayString(button2text.value), 3))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-primary ml-auto", buttonstyle.value]),
            "data-dismiss": "modal",
            onClick: button1Clicked
          }, _toDisplayString(button1text.value), 3)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})